import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IncreasedIncomeWarning } from '@/components/IncreasedIncomeWarning';
import { useGetLoansByFundraisingId } from '@/query/queries/loan/useGetLoansByFundraisingId';
import { Preloader } from '@/components/Preloader';
import { Header } from './header';
import { Brands } from './brands';
import { LoanDetails } from './details';
import { FundsRecovery } from './recovery';
import { RepaymentSchedule } from './schedule';
import { RepaymentHistory } from './history';
import { FinanceAgreements } from './agreements';
import { LoanSecurity } from './security';
import { LoanEarningsSchedule } from './earnings';
import { Filter } from './filter';
import s from './index.module.scss';

const APRIL_ROUND_ID_2024 = 94;

export const LoanInfo = ({ info }) => {
  const { t } = useTranslation('loans');
  const [group, setGroup] = useState();
  const { fundraising_id } = info;
  const { data: loans, isLoading } = useGetLoansByFundraisingId(fundraising_id);

  return (
    <div className={s.wrapper}>
      <h1 className="f-hero-h5">{t('loans')}</h1>
      <div className={s.content}>
        <Header info={info} />
        {isLoading ? (
          <Preloader style={{ height: '30vh' }} />
        ) : (
          <>
            <Brands fundraisingID={fundraising_id} />
            <LoanDetails group={group} fundraisingID={fundraising_id} />
            {fundraising_id >= APRIL_ROUND_ID_2024 && (
              <LoanEarningsSchedule
                group={group}
                fundraisingID={fundraising_id}
              />
            )}
            <IncreasedIncomeWarning currentDate={info.start_date} />
            <FundsRecovery fundraisingID={fundraising_id} />
            <Filter
              loans={loans}
              group={group}
              onClick={group => setGroup(group)}
            />
            <RepaymentSchedule group={group} fundraisingID={fundraising_id} />
            <RepaymentHistory group={group} fundraisingID={fundraising_id} />
            <FinanceAgreements
              group={group}
              fundraisingID={fundraising_id}
              info={info}
            />
            <LoanSecurity fundraisingID={fundraising_id} />
          </>
        )}
      </div>
    </div>
  );
};
